module.exports = __webpack_public_path__ + "static/media/premiumpositioning.24768e21.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/letterfunnel/premiumpositioning.webp
// module id = 655
// module chunks = 0